@for (participant of participants; track participant.id; let index = $index) {
    <li>
        @if (!isFavourites) {
            <span class="participant-caption resulted-caption-text">{{ sitecoreCommonIndex(index) }}</span>
        } @else {
            <span class="participant-caption resulted-caption-text" [innerHTML]="participant.favouriteRank"> </span>
        }

        <div class="participant-container value-text">
            <div class="number-silk-container">
                <span class="participant-number">{{ participant.properties!.raceCardNumber }}</span>
                @if (participant.timeformInfo) {
                    <ms-horses-silk [src]="participant.timeformInfo.silkUrl" [description]="participant.timeformInfo.silkDescription" />
                }
            </div>

            <div class="horse-name-container">
                <span class="participant-name">{{ participant.name | msTranslate }}</span>
            </div>

            <div class="jockey-name-container">
                <span class="jockey-name">{{ participant.properties!.jockey }}</span>
            </div>

            @if (isOptionBet) {
                <span class="participant-odds">{{ getParticipantOption(participant.id) | msExternalPriceFormatter }}</span>
            } @else if (!isOptionBet && prices[participant.id]) {
                <span class="participant-odds">{{ prices[participant.id]!.price | msExternalPriceFormatter }}</span>
            }
        </div>
    </li>
}
